import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const AboutPage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Set page title and meta tags
    document.title = 'Hakkımızda - Es Donanım Bilgisayar | Güvenilir Bilgisayar Servisi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Es Donanım Bilgisayar olarak Ankara\'da 2. el bilgisayar alım satım ve teknik servis hizmeti sunuyoruz. Uzman kadromuz, uygun fiyatlar ve müşteri memnuniyeti odaklı çalışma anlayışımızla yanınızdayız.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'hakkımızda, es donanım bilgisayar, bilgisayar servisi ankara, güvenilir bilgisayar tamiri, 2. el bilgisayar uzmanı, teknik servis ankara');
    }
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${siteUrl}/hakkimizda`);
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "Organization",
        "name": "Es Donanım Bilgisayar",
        "url": siteUrl,
        "logo": `${siteUrl}/logo.png`,
        "description": "Ankara'da güvenilir 2. el bilgisayar alım satım ve teknik servis hizmeti sunan profesyonel firma",
        "foundingDate": "2010",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Anafartalar Cad. Ulus Şehir Çarşısı No:3/11",
          "addressLocality": "Altındağ",
          "addressRegion": "Ankara",
          "postalCode": "06030",
          "addressCountry": "TR"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+905065376985",
          "contactType": "customer service",
          "email": "info@esbilgisayar.com.tr",
          "areaServed": "TR",
          "availableLanguage": "Turkish"
        },
        "sameAs": [
          "https://www.facebook.com/esbilgisayar",
          "https://www.instagram.com/esbilgisayar",
          "https://twitter.com/esbilgisayar"
        ]
      }
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white py-20">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/4aa5ccd7d7bba3a9187b4bf0b15f3585.jpg')] bg-cover bg-center opacity-10"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl lg:text-5xl font-bold mb-6">
                Es Donanım Bilgisayar Hakkında
              </h1>
              <p className="text-xl text-blue-100">
                Ankara'da güvenilir 2. el bilgisayar alım satım ve teknik servis hizmetinde öncü firmayız
              </p>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
                <div>
                  <img
                    src="https://readdy.ai/api/search-image?query=professional%20computer%20repair%20technician%20examining%20laptop%20motherboard%20with%20magnifying%20glass%20and%20tools%20clean%20white%20background%20technical%20expertise%20detailed%20hardware%20inspection%20professional%20service%20quality&width=600&height=400&seq=about-story-1&orientation=landscape"
                    alt="Profesyonel Bilgisayar Tamiri"
                    className="w-full h-96 object-cover rounded-lg shadow-lg"
                  />
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-slate-900 mb-6">Hikayemiz</h2>
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    Es Donanım Bilgisayar, Ankara'da 2. el bilgisayar alım satım ve teknik servis alanında uzmanlaşmış, müşteri memnuniyetini ön planda tutan güvenilir bir firmadır. Yılların deneyimi ve sektördeki uzmanlığımızla, hem bireysel hem de kurumsal müşterilerimize en kaliteli hizmeti sunmayı hedefliyoruz.
                  </p>
                  <p className="text-slate-600 leading-relaxed">
                    İkinci el bilgisayar alım satımında şeffaf fiyatlandırma, bilgisayar tamiri ve teknik servis hizmetlerinde hızlı çözüm anlayışıyla çalışıyoruz. Her ürünümüzü titizlikle test ediyor, müşterilerimize garanti ile teslim ediyoruz.
                  </p>
                </div>
              </div>

              {/* Values */}
              <div className="mb-16">
                <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Değerlerimiz</h2>
                <div className="grid md:grid-cols-3 gap-8">
                  <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-lg border border-blue-100">
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i className="ri-shield-check-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3 text-center">Güvenilirlik</h3>
                    <p className="text-slate-600 text-center">
                      Tüm işlemlerimizde şeffaflık ve dürüstlük ilkesiyle hareket ediyor, müşterilerimize güvenilir hizmet sunuyoruz.
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-lg border border-orange-100">
                    <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i className="ri-user-heart-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3 text-center">Müşteri Odaklılık</h3>
                    <p className="text-slate-600 text-center">
                      Müşteri memnuniyeti bizim için her şeyden önce gelir. İhtiyaçlarınıza özel çözümler üretiyoruz.
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-lg border border-blue-100">
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4 mx-auto">
                      <i className="ri-tools-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3 text-center">Uzmanlık</h3>
                    <p className="text-slate-600 text-center">
                      Deneyimli teknik ekibimiz, en karmaşık sorunlara bile profesyonel çözümler üretiyor.
                    </p>
                  </div>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="bg-gradient-to-br from-slate-50 to-blue-50 p-8 lg:p-12 rounded-lg">
                <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Neden Es Donanım Bilgisayar?</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Uygun Fiyat Garantisi</h4>
                      <p className="text-slate-600">2. el bilgisayar alım satımında ve teknik servis hizmetlerinde en uygun fiyatları sunuyoruz.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Hızlı Servis</h4>
                      <p className="text-slate-600">Bilgisayar tamiri ve laptop tamiri işlemlerinizi en kısa sürede tamamlıyoruz.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Garanti Güvencesi</h4>
                      <p className="text-slate-600">Tüm ürünlerimiz ve servis hizmetlerimiz garanti kapsamındadır.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Uzman Kadro</h4>
                      <p className="text-slate-600">Deneyimli teknisyenlerimiz her türlü bilgisayar sorununa profesyonel çözüm üretiyor.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Geniş Ürün Yelpazesi</h4>
                      <p className="text-slate-600">İkinci el laptop, masaüstü bilgisayar ve oyuncu bilgisayarı gibi geniş ürün seçeneklerimiz var.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 mb-2">Merkezi Konum</h4>
                      <p className="text-slate-600">Ankara Ulus'ta merkezi konumumuzla kolayca ulaşabilirsiniz.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-br from-blue-900 to-slate-900 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Bilgisayar İhtiyaçlarınız İçin Bize Ulaşın
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              2. el bilgisayar alım satım, bilgisayar tamiri ve teknik servis hizmetlerimiz hakkında detaylı bilgi almak için bizimle iletişime geçin.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:+905065376985"
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905065376985"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default AboutPage;